/**
 * How a floor number is written.
 *
 * `modules.floor` is a signed integer: 1..14 climb the tower, and -1, -2 go
 * beneath it into the Understructure — B1 JavaScript, B2 Python. That choice
 * costs no schema change (the column was already signed and unique, and
 * Tower.tsx already sorted descending), but it does mean a raw render prints
 * "-1" where a reader expects "B1".
 *
 * One helper, imported everywhere a floor number is displayed, so the tower map
 * and the boss screen and the collection book cannot disagree about what to
 * call the same floor.
 */

export function floorLabel(floor: number): string {
  return floor < 0 ? `B${-floor}` : String(floor)
}

/** True for the language floors beneath the tower. */
export function isUnderstructure(floor: number): boolean {
  return floor < 0
}

/**
 * Understructure floors are never locked.
 *
 * Deliberate, and worth stating where the code can see it: someone who cannot
 * yet read a `.then()` chain cannot honestly do Floor 1, and gating the remedy
 * behind the thing it remedies is a trap. They are also optional — a reader who
 * already knows JavaScript should be able to walk past B1 without a nag.
 */
export function isAlwaysUnlocked(floor: number): boolean {
  return isUnderstructure(floor)
}
